import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { BlockDirective } from '../../components/block/block.directive';
import { ButtonComponent } from '../../components/button/button.component';
import { IconComponent } from '../../components/icon/icon.component';
import { OverlayComponent } from '../../components/overlay/overlay.component';
import { OverlayHeaderComponent } from '../../components/overlay/overlay-header.component';
import { OverlayToggleDirective } from '../../components/overlay/overlay-toggle.directive';
import { ChatService } from './chat.service';
import type { OverlayAsyncOpenEvent } from '../../components/overlay/overlay-factory.service';

@Component({
  selector: 'td-wb-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  imports: [
    ButtonComponent,
    BlockDirective,
    OverlayToggleDirective,
    IconComponent,
    OverlayComponent,
    OverlayHeaderComponent,
    TranslateDirective,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatComponent {
  displayChatButton: boolean = false;
  loading: boolean = false;
  asyncOpenEvent: OverlayAsyncOpenEvent;

  constructor(private chatService: ChatService,
              private changeDetectorRef: ChangeDetectorRef) {
    this.chatService.displayChatButton
      .pipe(takeUntilDestroyed())
      .subscribe((displayChatButton: boolean): void => {
        this.displayChatButton = displayChatButton;
        if(this.displayChatButton) {
          this.loading = false;
        }
        this.changeDetectorRef.markForCheck();
      });
    this.chatService.widgetLoadError
      .pipe(takeUntilDestroyed())
      .subscribe((widgetLoadError: boolean): void => {
        if(widgetLoadError) {
          this.loading = false;
          if(this.asyncOpenEvent !== undefined) {
            this.asyncOpenEvent.open();
          }
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  openChat(): void {
    this.loading = true;
    this.chatService.loadWidget();
  }

  asyncOpen(event: OverlayAsyncOpenEvent): void {
    this.asyncOpenEvent = event;
  }
}
